export default {
    "fr": {
        "My bookings": "Mes réservations",
        "No bookings": "Aucune réservation pour le moment",
        "Book": "Réserver",
        "Bookings": "Réservations",
        "Notes": "Notes",
        "Any comments to forward us ?": "Des commentaires à nous transmettre ?",
        "Book a mission": "Réserver une intervention",
        "Booking #": "Réservation #",
        "statuses": {
            "achieved": "Terminée",
            "canceled": "Annulée",
            "pending-prepayment": "Attente du pré-paiement",
            "pending-signature": "Attente de la signature"
        },
        "Choose": "Choisir",
        "Type": "Type de mission",
        "Customs type": "Type de douane",
        "Site": "Site",
        "Place": "Où arrivez-vous ?",
        "Registrations": "Immatriculations",
        "Reference": "Référence",
        "Registration towing": "Immatriculation tracteur",
        "Registration trailer": "Immatriculation remorque",
        "Add a truck": "Ajouter un camion",
        "Truck": "Camion",
        "Trucks": "Camions",
        "Remove": "Retirer",
        "Documents": "Documents",
        "My documents": "Mes documents",
        "Booking achieved": "Réservation terminée",
        "Mandate": "Mandat de représentation",
        "Mandate signed on": "Mandat de représentation signé le ",
        "Prepayment": "Prépaiement",
        "Prepayment of": "Prépaiement de ",
        "validated on": "validé le",
        "No prepayment": "Prépaiement non demandé pour cette réservation",
        "Sign mandate": "Signer le mandat",
        "History": "Historique",
        "Prepay": "Prépayer",
        "Quick booking": "Réservation rapide",
        "Assisted booking": "Réservation assistée",
        "You need help?": "Vous avez besoin d'aide ?",
        "Use our booking assistant": "Utilisez notre assistant de réservation",
        "Continue": "Continuer",
        "Click here": "Cliquez ici",
        "I choose my services": "Je choisis mes services",
        "Certificate 846A": "Le certificat 846 A atteste que vous avez payé les droits de douane et les taxes à la préfecture pour l'importation d'un véhicule.",
        "Documents list": "Liste des documents à fournir :",
        "Empty document for the moment": "Aucun document pour le moment.",
        "Documentary control": "Contrôle documentaire des certificats sanitaires",
        "I do it myself": "Je le fais moi-même",
        "Do it for me": "Faites-le pour moi",
        "Simple service": "Prestation simple (sans impression)",
        "Simple desc": "Accueil du chauffeur, notification auprès de vos services",
        "Complete desc": "Accueil du chauffeur, notification auprès de vos services, impression des documents pour le chauffeur, libération du chauffeur à réception du BAE",
        "Complete service": "Prestation complète (avec impression)",
        "Clearance transit": "Apurement de transit",
        "Clearance transit desc": "Accueil du chauffeur, notification auprès de vos services, impression des documents pour le chauffeur, libération du chauffeur à réception du BAE",
        "Add a document": "Ajouter un document ...",
        "Your booking reference": "Votre référence dossier",
        "Booking message": "Cher client, merci de bien noter et conserver <b>votre référence dossier {reference}</b>, votre chauffeur devra présenter cette référence à notre personnel lors de sa venue dans nos locaux afin d'être correctement identifié.",
        "Booking assistant": "Assistant de réservation",
        "My booking": "Ma réservation",
        "Do you want more services ?": "Vous souhaitez plus de services ?",
        "Do not forget to add all your services": "N'oubliez pas de commander <strong class='text-dark'>toutes vos prestations</strong> (dédouanement, assistance).",
        "Add a book": "Ajouter des services",
        "Thorough control": "Contrôle approfondi des certificats sanitaire avec frais additionnels",
        "Animals type": "Type d'animaux",
        "moving text": "Vous quittez un pays tiers au profit de la citoyenneté Européenne, vous pouvez bénéficier d’une importation en franchise de droits et taxes. Vous devez nous fournir un document officiel provenant de chaque pays indiquant que vous perdez la citoyenneté du pays que vous quitter au profit de la citoyenneté de votre futur pays de résidence (TOR, Inscription au service de sécurité social etc…) Vous devez également fournir un inventaire détaillé, estimé, daté et signé (en 2 exemplaires) des effets et objets mobiliers dont l'importation est envisagée. Nous aurons également besoin de votre pièce d'identité, de justificatifs de domicile et du CERFA 10070 si vous emménagez en France.",
        "personal_effects text": "Vous transportez vos effets personnels entre vos résidences situées à l’intérieur et en dehors de la communauté européenne, vous devez payer des taxes lors de l’importation dans l’UE. Vous devez fournir un inventaire détaillé, estimé, daté et signé (en 2 exemplaires) des effets et objets mobiliers dont l'importation est envisagée.",
        "military_equipment text": "Ce type de matériel est soumis à accord d’un responsable, nous vous recontacterons dans les plus brefs délais pour vous tenir informé de la faisabilité",
        "Back": "Retour",
        "Next": "Suivant",
        "services": {
            "customs": "Douane - EU / EX / IM / T1 - T2",
            "sivep": "Sivep - DSCE - CS",
            "customs-sivep": "Douane + Sivep",
            "parking": "Parking Stop / Apurement T2"
        },
        "Incoterm": "Incoterm",
        "Transport cost": "Coût du transport",
        "Crossing date": "Date de passage",
        "Crossing place": "Lieu de passage",
        "Drag and drop documents": "Glissez vos documents ici ou cliquez sur le bouton ci-dessous",
        "846A": "846A",
        "CHED": "DSCE (CHED)",
        "Templates": "Modèles",
        "My templates": "Mes modèles",
        "Template": "Modèle",
        "Close": "Fermer",
        "Or use one of my templates": "Ou utilisez l'un de vos modèles enregistrés",
        "Template used": "Modèle utilisé",
        "Template updated": "Modèle mis à jour",
        "Template deleted": "Modèle supprimé",
        "Template name": "Nom de votre modèle",
        "Template save": "Sauvegarde de votre modèle",
        "Save template": "Enregistrer ce modèle",
        "Edit my template": "Modifier mon modèle",
        "Update template": "Mettre à jour mon modèle",
        "Additionals services": "Services complémentaires",
        "Choose your service": "Choisissez votre service",
        "Choose your additionals service": "Choisissez vos services complémentaires",
        "Choose your template": "Choisissez votre modèle",
        "Your added documents": "Vos documents ajoutés",
        "Add my documents": "Ajouter mes documents",
        "Services": "Services",
        "Informations": "Informations",
        "Information": "Information",
        "Resume": "Récapitulatif",
        "Your informations": "Vos informations",
        "Your documents": "Vos documents",
        "This mission pattern is recurring": "Ce modèle de réservation ci-dessous est récurrent ?",
        "Save it and save time on your next booking": "Sauvegardez-le et gagnez du temps lors de votre prochaine réservation.",
        "Edit document": "Modifier le document",
        "Edit": "Modifier",
        "Delete": "Supprimer",
        "Document name": "Nom du document",
        "Document type": "Type de document",
        "Document error size": "Le fichier de {size} excède la taille autorisée de {maxSize} MB.",
        "Document error extension": "L'extension .{extension} de votre fichier n'est pas autorisée. Sont autorisées : {extensions}",
        "helpers": {
            "customs": "ASA réalise vos formalités douanières IMPORT / EXPORT / TRANSIT, pour tout type de marchandise. Que ce soit des animaux vivants, des produits alimentaires, des voitures, des pièces détachées ou des effets personnels, nous sommes experts dans chaque domaine. Faites confiance à notre savoir-faire pour faciliter vos échanges internationaux.",
            "sivep": "ASA vous accompagne 24/7 pour vos formalités sanitaires sur les sites de Calais Port, Calais Tunnel et Dunkerque. Nous prenons en charge la création de DSCE/CHED, la représentation SIVEP, la représentation auprès de la Douane, les Carnets ATA, et bien plus encore. Profitez de notre disponibilité constante pour assurer la conformité de vos marchandises aux normes sanitaires.",
            "customs-sivep": "ASA est votre partenaire privilégié pour les formalités douanières et sanitaires. Nous prenons en charge vos besoins d'importation, d'exportation et de transit de marchandises. De plus, notre assistance 24/7 sur les sites de Calais Port, Calais Tunnel et Dunkerque garantit la conformité sanitaire de vos produits. Faites confiance à notre expertise complète pour faciliter vos échanges internationaux en toute tranquillité.",
            "parking": "ASA offre une assistance aux RDE et aux transporteurs lors des stops douane Export/Transit et import sous transit. Bénéficiez de notre parking 24/7 à Marck, stratégiquement situé près des sites transmanche. Vous pouvez ainsi bénéficier d'une solution pratique et sécurisée pour garer vos véhicules et assurer la gestion efficace de vos marchandises."
        },
        "Booking reference is": "La référence de votre dossier est",
        "View my folder": "Voir mon dossier",
        "Please select your client": "Merci de sélectionner votre client",
        "Please select your service": "Merci de sélectionner votre service",
        "This field is required": "Ce champs est requis",
        "Documents are required": "Vos documents sont requis",
        "Only": "Uniquement",
        "Full services": "Services complets",
        "Choose your client": "Choisissez votre client",
        "Select a client": "Sélectionnez un client...",
        "Client": "Ajouter un client"
    },
    "en": {
        "My bookings": "My bookings",
        "No bookings": "No bookings",
        "Book": "Book",
        "Bookings": "Bookings",
        "Notes": "Notes",
        "Any comments to forward us ?": "Any comments to forward us ?",
        "Book a mission": "Book a mission",
        "Booking #": "Booking #",
        "statuses": {
            "achieved": "Achieved",
            "canceled": "Canceled",
            "pending-prepayment": "Pending-prepayment",
            "pending-signature": "Pending-signature"
        },
        "Choose": "Choose",
        "Type": "Type",
        "Customs type": "Customs type",
        "Site": "Site",
        "Place": "Where do you arrive ?",
        "Registrations": "Registrations",
        "Reference": "Reference",
        "Registration trailer": "Trailer registration",
        "Registration towing": "Truck registration",
        "Add a truck": "Add a truck",
        "Truck": "Truck",
        "Trucks": "Trucks",
        "Remove": "Remove",
        "Documents": "Documents",
        "My documents": "My documents :",
        "Booking achieved": "Booking achieved",
        "Mandate": "Mandate",
        "Mandate signed on": "Mandate signed on ",
        "Prepayment": "Prepayment",
        "Prepayment of": "Prepayment of ",
        "validated on": "validated on",
        "No prepayment": "No prepayment",
        "Sign mandate": "Sign mandate",
        "History": "History",
        "Prepay": "Prepay",
        "Quick booking": "Quick booking",
        "Assisted booking": "Assisted booking",
        "You need help?": "You need help?",
        "Use our booking assistant": "Use our booking assistant",
        "Continue": "Continue",
        "Click here": "Click here",
        "I choose my services": "I choose my services",
        "Certificate 846A": "The 846 A certificate certifies that you have paid customs duties and taxes to the prefecture for the importation of a vehicle.",
        "Documents list": "Documents list :",
        "Empty document for the moment": "No documents for the moment",
        "Documentary control": "Documentary check of your health certificates",
        "I do it myself": "I do it myself",
        "Do it for me": "Do it for me",
        "Simple service": "Simple service (without customs documents printed)",
        "Simple desc": "Welcome of the driver, notification to your services",
        "Complete desc": "Welcome of the driver, notification to your services, printing of documents for the driver, release of the driver upon receipt of the validated customs declaration",
        "Complete service": "Complete service (customs documents printed)",
        "Clearance transit": "Clearance transit",
        "Clearance transit desc": "Welcome of the driver, notification to your services, printing of documents for the driver, release of the driver upon receipt of the validated customs declaration",
        "Add a document": "Add a document ...",
        "Your booking reference": "Your booking reference",
        "Booking message": "Dear customer, please note and keep <b>your booking number {reference} </b>, your driver must present this booking reference to our staff when he comes to our office in order to be correctly identified.",
        "Booking assistant": "Booking assistant",
        "My booking": "My booking",
        "Do you want more services ?": "Do you need more services ?",
        "Do not forget to add all your services": "Do not forget to book <strong class='text-dark'>all your services </strong> (customs clearance, assistance).",
        "Add a book": "Add more services",
        "Thorough control": "Thorough check of health certificates with additional costs",
        "Animals type": "Animals type",
        "moving text": "You leave a third country for the benefit of European citizenship; you can benefit from an import free of duties and taxes.You must provide us with an official document from each country indicating that you are losing the citizenship of the country you are leaving in favor of the citizenship of your future country of residence (TOR, registration with the social security service, etc.) You must also provide a detailed, estimated, dated and signed inventory (in 2 copies) of the household effects and objects whose importation is planned.We will also need your ID, proof of address and CERFA 10070 if you are moving to France.",
        "personal_effects text": "You transport your personal effects between your residences located inside and outside the European community, you must pay taxes when importing into the EU. You must provide a detailed, estimated, dated and signed inventory (in 2 copies) of the household effects and objects whose importation is planned.",
        "military_equipment text": "This type of material is subject to the agreement of a manager, we will contact you as soon as possible to keep you informed of the feasibility.",
        "Back": "Back",
        "Next": "Next",
        "services": {
            "customs": "Customs - EU / EX / IM / T1 - T2",
            "sivep": "Sivep - CHED - EHC",
            "customs-sivep": "Customs + Sivep",
            "parking": "Parking Stop / T2 clearance"
        },
        "Incoterm": "Incoterm",
        "Transport cost": "Transport cost",
        "Crossing date": "Crossing date",
        "Crossing place": "Crossing place",
        "Drag and drop documents": "Drag and drop documents or click the button below",
        "846A": "846A",
        "CHED": "CHED",
        "Templates": "Templates",
        "My templates": "My templates",
        "Template": "Template",
        "Close": "Close",
        "Or use one of my templates": "Or use a saved template",
        "Template used": "Template used",
        "Template updated": "Template updated",
        "Template deleted": "Template deleted",
        "Template name": "Template name",
        "Template save": "Save your template",
        "Save template": "Save template",
        "Edit my template": "Edit my template",
        "Update template": "Update template",
        "Additionals services": "Additionnals services",
        "Choose your service": "Choose your service",
        "Choose your additionals service": "Choose your additionnals services",
        "Choose your template": "Choose your template",
        "Your added documents": "Your added documents",
        "Add my documents": "Add my documents",
        "Services": "Services",
        "Informations": "Informations",
        "Information": "Information",
        "Resume": "Summary",
        "Your informations": "Your informations",
        "Your documents": "Your documents",
        "This mission pattern is recurring": "This booking pattern is recurring?",
        "Save it and save time on your next booking": "Save it and save time on your next booking",
        "Edit document": "Edit document",
        "Edit": "Edit",
        "Delete": "Delete",
        "Document name": "Document name",
        "Document type": "Document type",
        "Document error size": "Your file size ({size}) exceeds the allowed size of {maxSize} MB.",
        "Document error extension": "The extension .{extension} of your file is not allowed. Are allowed: {extensions}",
        "helpers": {
            "customs": "ASA handles your customs formalities for IMPORT/EXPORT/TRANSIT, covering all types of goods. Whether it's live animals, food products, cars, spare parts, or personal effects, we are experts in each domain. Trust our expertise to streamline your international trade.",
            "sivep": "ASA provides 24/7 support for your sanitary formalities at Calais Port, Calais Tunnel, and Dunkirk. We take care of DSCE/CHED creation, SIVEP representation, Customs representation, ATA Carnets, and much more. Benefit from our constant availability to ensure compliance with sanitary standards for your goods.",
            "customs-sivep": "ASA is your trusted partner for customs and sanitary formalities. We handle your import, export, and transit requirements. Additionally, our 24/7 assistance at Calais Port, Calais Tunnel, and Dunkirk ensures the sanitary compliance of your products. Trust our comprehensive expertise to facilitate your international trade with peace of mind.",
            "parking": "ASA offers assistance to RDEs and carriers during Export/Transit and import-under-transit customs stops. Take advantage of our 24/7 parking facility near all trans-channel sites in Marck. Enjoy a convenient and secure solution to park your vehicles and efficiently manage your goods."
        },
        "Booking reference is": "Booking reference is",
        "View my folder": "View my folder",
        "Please select your client": "Please select your client",
        "Please select your service": "Please select your service",
        "This field is required": "This field is required",
        "Documents are required": "Documents are required",
        "Only": "Only",
        "Full services": "Full services",
        "Choose your client": "Choose your client",
        "Select a client": "Select a client ...",
        "Client": "Add a client"
    }
}
